/**
 * Keeps cart drawer footer controls in the tab order when the shadow footer
 * slot was left hidden after cart updates.
 */
(function () {
  function syncFooterAccessibility(drawer) {
    const footerPart = drawer.shadowRoot?.querySelector('[part="footer"]');
    const footerSlot = drawer.shadowRoot?.querySelector('slot[name="footer"]');
    if (!footerPart || !footerSlot) {
      return;
    }

    const hasFooterContent = drawer.querySelector("form.cart-drawer__footer");
    const assignedCount = footerSlot.assignedElements({ flatten: true }).length;

    if (hasFooterContent || assignedCount > 0) {
      footerPart.removeAttribute("hidden");
    } else {
      footerPart.hidden = true;
    }
  }

  function initCartDrawer(drawer) {
    syncFooterAccessibility(drawer);

    drawer.addEventListener("dialog:before-show", () => syncFooterAccessibility(drawer));
    drawer.addEventListener("dialog:after-show", () => syncFooterAccessibility(drawer));
    drawer.addEventListener("cart-drawer:refreshed", () => syncFooterAccessibility(drawer));
  }

  function boot() {
    document.querySelectorAll("cart-drawer").forEach(initCartDrawer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
